import { RefObject } from 'react';

import LNB from '@/components/common/LNB';
import LNBAccount from '@/outlets/ContainerOutlet/LNBLayout/LNBAccount';
import LNBMenu from '@/outlets/ContainerOutlet/LNBLayout/LNBMenu';

type Props = {
  outerRef: RefObject<HTMLElement | null>;
};

const LNBLayout = ({ outerRef }: Props) => {
  return (
    <LNB outerRef={outerRef}>
      <LNB.Header>
        <LNBAccount />
      </LNB.Header>
      <LNBMenu />
    </LNB>
  );
};

export default LNBLayout;
